/* DAJO PDP v3 - JavaScript de los bloques del lote v2.1, movido fuera del HTML (6 oct 2026, paquete de reinicio prueba 2).
   Se carga con defer desde snippets/dajo-pdp-v3-head.liquid. Lee window.DAJO_PDP (lo define el bloque 'orden de la primera pantalla').
   Cada bloque conserva su HTML y su CSS en la plantilla; aqui va su <script> tal cual, en el mismo orden, envuelto en su propia funcion. */
(function () {
  'use strict';
  var CFG = window.DAJO_PDP || {};
  var PID = CFG.pid;
  if (!PID) { if (window.console) console.warn('dajo-pdp-v3.js: falta window.DAJO_PDP'); return; }

  /* ===== compactar 1/1: Celular: compactar la primera pantalla v4 (candado barra de anuncios) ===== */
  (function () {
  (function () {
    // Candado: si el tema vuelve a escribir la altura de la barra de anuncios, la regresa a 0 en celular
    function sinBarra() {
      if (window.innerWidth > 767) return;
      document.documentElement.style.setProperty('--announcement-bar-height', '0px', 'important');
      var h = document.getElementById('shopify-section-sections--27368625963322__header');
      if (h) h.style.setProperty('top', '0px', 'important');
    }
    sinBarra();
    window.addEventListener('load', sinBarra);
    window.addEventListener('resize', sinBarra);
    try {
      new MutationObserver(sinBarra).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    } catch (e) {}
  })();
  })();

  /* ===== zoom 1/1: Galeria: abrir el zoom al tocar la foto ===== */
  (function () {
  (function () {
    var gal = document.querySelector('product-gallery');
    if (!gal || gal.getAttribute('data-dajo-tap') === '1') return;
    gal.setAttribute('data-dajo-tap', '1');

    var car = gal.querySelector('.product-gallery__carousel');
    if (!car) return;

    // Toque en la foto = abrir el zoom (si el dedo se movió más de 8 px, fue un deslizamiento)
    var sx = 0, sy = 0;
    car.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; }, { passive: true });
    car.addEventListener('click', function (e) {
      var img = e.target && e.target.closest && e.target.closest('.product-gallery__media[data-media-type="image"] img');
      if (!img) return;
      if (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8) return;
      var btn = gal.querySelector('button[is="open-lightbox-button"]');
      if (btn) { e.preventDefault(); btn.click(); }
    });

    // Toque en el fondo oscuro = cerrar el zoom
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      var esFondo = t.classList.contains('pswp__bg') || t.classList.contains('pswp__item') || t.classList.contains('pswp__zoom-wrap');
      if (!esFondo) return;
      var p = t.closest('.pswp');
      var cerrar = p && (p.querySelector('button[aria-label="Cerrar galería"]') || p.querySelector('.pswp__button--close'));
      if (cerrar) cerrar.click();
    }, true);
  })();
  })();

  /* ===== estrellas 1/1: Estrellas con calificacion (Judge.me) ===== */
  (function () {
(function () {
  function pinta() {
    document.querySelectorAll('.jdgm-prev-badge').forEach(function (b) {
      var t = b.querySelector('.jdgm-prev-badge__text');
      if (!t) return;
      var r = parseFloat(b.getAttribute('data-average-rating'));
      var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
      if (!r || !n) return;
      var r1 = (Math.round(r * 10) / 10).toFixed(1).replace(/\.0$/, '');
      var html = '<span class="dajo-calif">' + r1 + '</span> de ' + n.toLocaleString('es-MX') + ' rese\u00f1as';
      if (t.innerHTML !== html) t.innerHTML = html;
    });
  }
  pinta();
  window.addEventListener('load', pinta);
  // Judge.me vuelve a escribir el texto al terminar de cargar: se repinta cada vez que lo toque
  try {
    new MutationObserver(function () { pinta(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();
  })();

  /* ===== pitch 1/1: Mini-descripcion v4.1: dias segun material ===== */
  (function () {
(function () {
  var el = document.getElementById('dajo-pitch-' + PID + '');
  if (!el) return;
  var plataDias = el.getAttribute('data-plata') || '4 a 5';
  var oroDias   = el.getAttribute('data-oro') || '10 a 15';
  var diasEl    = el.querySelector('[data-pitch-dias]');

  function materialEsOro() {
    var texto = '';
    document.querySelectorAll('select').forEach(function (s) {
      var opts = s.textContent || '';
      if (/plata/i.test(opts) && /oro/i.test(opts)) texto += ' ' + s.value;
    });
    document.querySelectorAll('input:checked').forEach(function (i) {
      var v = i.value || '';
      if (/plata|oro/i.test(v)) texto += ' ' + v;
      if (i.id) {
        var lbl = document.querySelector('label[for="' + i.id + '"]');
        if (lbl && /plata|oro/i.test(lbl.textContent)) texto += ' ' + lbl.textContent;
      }
    });
    return /oro/i.test(texto);
  }

  function actualiza() {
    diasEl.textContent = materialEsOro() ? oroDias : plataDias;
  }

  actualiza();
  document.addEventListener('change', function (e) {
    if (e.target && /select|input/i.test(e.target.tagName)) actualiza();
  });
  document.addEventListener('variant:change', actualiza);
  document.addEventListener('variantChange', actualiza);
})();
  })();

  /* ===== selectores 1/1: Selectores v3 v5 ===== */
  (function () {
(function () {
  var PID = CFG.pid;
  // Etiqueta por opción en tarjetas (valor exacto → texto). Vacío = sin etiqueta.
  var TAGS = { 'Plata .925': 'Más elegido', 'Chico (10x10 mm)': 'Más elegido' };
  // Grabado: nombre corto, etiqueta y texto. {precio} se rellena con lo que diga la opción (p. ej. "+$100") o se omite.
  var GRABADO = {
    none:   { nombre: 'Sin grabado', tag: '',            texto: 'La pieza lisa, sin inicial.' },
    punzon: { nombre: 'Punzón',      tag: 'Incluido',    texto: 'Hecha a mano, golpe a golpe. 1 a 2 iniciales, incluido en el precio.' },
    laser:  { nombre: 'Láser',       tag: 'Más detalle', texto: 'Trazo fino y preciso, varios estilos de letra. {precio}.' }
  };
  var ES_TALLA = /talla|tama[nñ]o|largo|medida|size/i;
  var ES_GRABADO = /grabado/i;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); }
  function partes(v) {
    var m = v.match(/^(\S+)\s*(.*)$/);
    var main = m ? m[1] : v;
    var sub = m ? m[2] : '';
    sub = sub.replace(/^\(/, '').replace(/\)$/, '');
    return { main: main, sub: sub };
  }
  // "Grabado con letra de golpe" → punzon · "Grabado Láser" → laser · "Sin grabado" → none
  function claveGrabado(v) {
    var n = norm(v);
    if (n.indexOf('laser') >= 0) return 'laser';
    if (n.indexOf('golpe') >= 0 || n.indexOf('punzon') >= 0) return 'punzon';
    if (n.indexOf('sin') === 0 || n === 'none' || n.indexOf('singrabado') >= 0) return 'none';
    return v;
  }
  function tituloPaso(el, num, texto) { el.innerHTML = '<span class="dajo-sel__paso">' + num + '.</span>' + esc(texto); }
  // Enlace "Ver ejemplos reales ›" (una sola vez) que baja al bloque "¿Cómo se verá mi inicial?"
  var linkEjemplosPuesto = false;
  function linkEjemplos(el) {
    if (linkEjemplosPuesto || !el) return;
    var destino = document.getElementById('dajo-engrave-' + PID) || document.querySelector('.dajo-pdp-engrave');
    if (!destino) return;
    if (!destino.id) destino.id = 'dajo-engrave-' + PID;
    linkEjemplosPuesto = true;
    var a = document.createElement('a');
    a.className = 'dajo-paso__link';
    a.href = '#' + destino.id;
    a.textContent = 'Ver ejemplos reales ›';
    a.addEventListener('click', function (e) { e.preventDefault(); destino.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    el.appendChild(a);
  }

  /* ---------- Foto según material + técnica ---------- */
  function materialActual() {
    var sels = document.querySelectorAll('variant-picker select');
    for (var i = 0; i < sels.length; i++) {
      var fs = sels[i].closest('fieldset');
      var lg = fs && fs.querySelector('legend');
      var nombre = lg ? lg.textContent : '';
      if (!ES_TALLA.test(nombre) && !ES_GRABADO.test(nombre)) return sels[i].value; // "Plata .925", "Oro 14k"
    }
    return null;
  }
  function tecnicaActual() {
    var t = document.getElementById('grabado-type-sel-' + PID);
    var v = t ? t.value : '';
    if (!t) {
      var sels = document.querySelectorAll('variant-picker fieldset.dajo-sel-seg select');
      if (sels.length) v = claveGrabado(sels[0].value);
    }
    if (v === 'punzon' || v === 'laser') return v;
    if (v === 'none') return 'singrabado';
    return '';
  }
  // Etiquetas en el alt de las fotos: "[Plata punzón]", "[Plata láser]", "[Plata sin grabado]", "[Oro10k Oro14k punzón]"…
  // Piezas sin opción de material (solo plata): se busca solo por técnica.
  function saltaFoto() {
    var g = document.querySelector('product-gallery');
    var car = g && g.carousel;
    if (!car || typeof car.select !== 'function') return;
    var mat = materialActual() || 'Plata .925';   // piezas solo de plata: se asume plata
    var matFull = norm(mat);
    var matGen = norm(mat.split(/\s+/)[0]);
    var tec = tecnicaActual();
    var cells = Array.prototype.slice.call(g.querySelectorAll('.product-gallery__carousel .product-gallery__media'));
    var alts = cells.map(function (c) { var i = c.querySelector('img'); return norm(i ? i.alt : ''); });
    // La infografía "Tipos de grabado: punzón y láser" menciona las dos técnicas: no cuenta
    function busca(fn) { for (var i = 0; i < cells.length; i++) { var a = alts[i]; if (a.indexOf('punzon') >= 0 && a.indexOf('laser') >= 0) continue; if (fn(a)) return i; } return -1; }
    var idx = -1;
    if (tec) {
      idx = busca(function (a) { return a.indexOf(matFull) >= 0 && a.indexOf(tec) >= 0; });
      if (idx < 0) idx = busca(function (a) { return a.indexOf(matGen) >= 0 && a.indexOf(tec) >= 0; });
    }
    if (idx < 0) idx = busca(function (a) { return a.indexOf(matFull) >= 0; });
    if (idx < 0) idx = busca(function (a) { return a.indexOf(matGen) >= 0; });
    if (idx < 0 || idx === car.selectedIndex) return;
    try { car.select(idx); } catch (e) {}
  }
  var saltoTimer = null;
  function programaSalto(ms) { clearTimeout(saltoTimer); saltoTimer = setTimeout(saltaFoto, ms || 350); }

  /* ---------- Control segmentado genérico (opción de variante o select del bloque de grabado) ---------- */
  function armaSegmentado(sel, host, onCambio) {
    var seg = document.createElement('div');
    seg.className = 'dajo-grab__seg';
    seg.setAttribute('role', 'group');
    var texto = document.createElement('p');
    texto.className = 'dajo-grab__texto';
    var opts = {};
    Array.prototype.forEach.call(sel.options, function (o) { opts[claveGrabado(o.value)] = o; });
    var orden = ['none', 'punzon', 'laser'];
    Array.prototype.forEach.call(sel.options, function (o) { var k = claveGrabado(o.value); if (orden.indexOf(k) < 0) orden.push(k); });
    orden.forEach(function (k) {
      var o = opts[k]; if (!o) return;
      var cfg = GRABADO[k] || { nombre: o.value, tag: '', texto: '' };
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dajo-grab__btn';
      b.setAttribute('data-value', o.value);
      b.innerHTML = '<span>' + esc(cfg.nombre) + '</span>' + (cfg.tag ? '<span class="dajo-grab__tag">' + esc(cfg.tag) + '</span>' : '');
      b.addEventListener('click', function () {
        if (sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        pinta();
        if (onCambio) onCambio();
      });
      seg.appendChild(b);
    });
    function precioDe(o) { var m = o.textContent.match(/\(([^)]+)\)/); return m ? m[1] : ''; }
    function pinta() {
      seg.querySelectorAll('.dajo-grab__btn').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-value') === sel.value ? 'true' : 'false'); });
      var k = claveGrabado(sel.value);
      var cfg = GRABADO[k];
      var t = cfg ? cfg.texto : '';
      var o = opts[k];
      var p = o ? precioDe(o) : '';
      if (/incluido/i.test(p)) p = '';
      t = t.replace('{precio}', p ? p : '').replace(/\s+\.$/, '.').replace(/\.\s*\.$/, '.');
      texto.textContent = t;
      texto.hidden = !t;
    }
    sel.addEventListener('change', pinta);
    host.appendChild(seg);
    host.appendChild(texto);
    pinta();
  }

  /* ---------- Opciones de la pieza (variant picker) ---------- */
  function armaPicker(vp) {
    if (vp.getAttribute('data-dajo-sel') === '1') return 0;
    vp.setAttribute('data-dajo-sel', '1');
    // Las opciones "Grabado…" se mueven al final, para que queden pegadas a los campos de grabado
    // (el tamaño / la talla / el material quedan primero). El picker sigue escuchando igual.
    var todos = Array.prototype.slice.call(vp.querySelectorAll('fieldset.variant-picker__option'));
    var deGrabado = todos.filter(function (fs) { var lg = fs.querySelector('legend'); return lg && ES_GRABADO.test(lg.textContent); });
    if (deGrabado.length && deGrabado.length < todos.length) {
      var ref = todos[todos.length - 1];
      deGrabado.forEach(function (fs) { ref.insertAdjacentElement('afterend', fs); ref = fs; });
    }
    var paso = 0;
    vp.querySelectorAll('fieldset.variant-picker__option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var sel = fs.querySelector('select');
      if (!legend || !sel) return;
      paso++;
      var nombre = legend.textContent.replace(/:\s*$/, '').trim();
      var host = sel.closest('[data-option-selector]') || sel;

      if (ES_TALLA.test(nombre)) {
        if (sel.options.length === 1) {                  // talla única: chip fijo, no es una decisión ni un paso
          paso--;
          legend.textContent = nombre;
          fs.classList.add('dajo-sel-unica');
          var chip = document.createElement('div');
          chip.className = 'dajo-sel__unica';
          chip.innerHTML = '<span>' + esc(sel.options[0].value.replace(/\(\s+/g, '(').replace(/\s+\)/g, ')')) + '</span><span class="dajo-sel__unica-tag">Única opción</span>';
          host.insertAdjacentElement('afterend', chip);
          return;
        }
        tituloPaso(legend, paso, 'Elige tu ' + nombre.toLowerCase());   // desplegable
        return;
      }
      if (ES_GRABADO.test(nombre)) {                     // segmentado
        tituloPaso(legend, paso, 'Elige tu ' + nombre.toLowerCase());
        linkEjemplos(legend);
        fs.classList.add('dajo-sel-seg');
        var cont = document.createElement('div');
        cont.className = 'dajo-grab';
        host.insertAdjacentElement('afterend', cont);
        armaSegmentado(sel, cont, function () { programaSalto(450); });
        return;
      }
      // tarjetas
      tituloPaso(legend, paso, 'Elige tu ' + nombre.toLowerCase());
      fs.classList.add('dajo-sel-cards');
      var wrap = document.createElement('div');
      wrap.className = 'dajo-sel';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', nombre);
      Array.prototype.forEach.call(sel.options, function (opt) {
        var p = partes(opt.value);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dajo-sel__btn';
        b.setAttribute('data-value', opt.value);
        b.setAttribute('aria-pressed', opt.selected ? 'true' : 'false');
        if (opt.disabled || opt.classList.contains('is-disabled')) b.classList.add('is-agotado');
        b.innerHTML =
          '<span class="dajo-sel__main">' + esc(p.main) + '</span>' +
          (p.sub ? '<span class="dajo-sel__sub">' + esc(p.sub) + '</span>' : '') +
          '<span class="dajo-sel__check" aria-hidden="true"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5l2.5 2.5 4.5-5"/></svg></span>' +
          (TAGS[opt.value] ? '<span class="dajo-sel__tag">' + esc(TAGS[opt.value]) + '</span>' : '');
        b.addEventListener('click', function () {
          if (sel.value === opt.value) return;
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          pinta();
          programaSalto(450);
        });
        wrap.appendChild(b);
      });
      function pinta() {
        wrap.querySelectorAll('.dajo-sel__btn').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-value') === sel.value ? 'true' : 'false');
        });
        Array.prototype.forEach.call(sel.options, function (opt) {
          var b = wrap.querySelector('.dajo-sel__btn[data-value="' + opt.value.replace(/"/g, '\\"') + '"]');
          if (b) b.classList.toggle('is-agotado', opt.disabled || opt.classList.contains('is-disabled'));
        });
      }
      sel.addEventListener('change', pinta);
      try { new MutationObserver(pinta).observe(sel, { attributes: true, subtree: true, attributeFilter: ['class', 'disabled', 'selected'] }); } catch (e) {}
      host.insertAdjacentElement('afterend', wrap);
    });
    return paso;
  }

  /* ---------- Bloque de grabado (Tipo de grabado) ---------- */
  function armaGrabado(numPaso, hayOpcionGrabado) {
    var typeSel = document.getElementById('grabado-type-sel-' + PID);
    var wrap = document.getElementById('grabado-type-wrap-' + PID);
    if (!typeSel || !wrap || wrap.getAttribute('data-dajo-seg') === '1') return;
    wrap.setAttribute('data-dajo-seg', '1');
    var label = wrap.querySelector('.engraving-addon__label--type');
    if (label) label.classList.add('dajo-oculto');
    typeSel.classList.add('dajo-oculto');

    if (hayOpcionGrabado) {
      // La pieza ya pregunta el grabado en sus opciones (Grabado dije 1, dije 2…): aquí no se vuelve a preguntar.
      // El select del bloque se sincroniza solo con lo elegido arriba para que salgan los campos correctos:
      // láser si alguna opción es láser, punzón si alguna es punzón, y "sin grabado" si todas son sin grabado.
      var tiene = {};
      Array.prototype.forEach.call(typeSel.options, function (o) { tiene[o.value] = true; });
      function sincroniza() {
        var sels = document.querySelectorAll('variant-picker fieldset.dajo-sel-seg select');
        var hayLaser = false, hayPunzon = false;
        sels.forEach(function (s) { var k = claveGrabado(s.value); if (k === 'laser') hayLaser = true; if (k === 'punzon') hayPunzon = true; });
        var deseado = 'none';
        if (hayLaser && tiene.laser) deseado = 'laser';
        else if ((hayLaser || hayPunzon) && tiene.punzon) deseado = 'punzon';
        else if (hayLaser && tiene.laser) deseado = 'laser';
        if (!tiene[deseado]) return;
        if (typeSel.value !== deseado) {
          typeSel.value = deseado;
          typeSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      document.querySelectorAll('variant-picker fieldset.dajo-sel-seg select').forEach(function (s) { s.addEventListener('change', function () { setTimeout(sincroniza, 0); }); });
      sincroniza();
      return;
    }

    var box = document.createElement('div');
    box.className = 'dajo-grab';
    var titulo = document.createElement('p');
    titulo.className = 'dajo-paso__titulo dajo-grab__titulo';
    tituloPaso(titulo, numPaso, 'Elige tu grabado');
    linkEjemplos(titulo);
    box.appendChild(titulo);
    wrap.insertBefore(box, wrap.firstChild);
    armaSegmentado(typeSel, box, function () { programaSalto(150); });
  }

  /* Campo de la inicial en lenguaje de clienta: "Tu inicial" y ayuda corta (el snippet compartido no se toca) */
  function etiquetaInicial() {
    var pz = document.getElementById('punzon-group-' + PID);
    if (!pz || pz.getAttribute('data-dajo-lbl') === '1') return;
    pz.setAttribute('data-dajo-lbl', '1');
    var labels = Array.prototype.slice.call(pz.querySelectorAll('label.engraving-addon__label'));
    labels.forEach(function (lbl) {
      var orig = (lbl.textContent || '').replace(/\(\s*m[aá]x\.?[^)]*\)/i, '').replace(/\*/g, '').replace(/\s+/g, ' ').trim();
      var ast = /\*/.test(lbl.textContent) ? ' <span aria-hidden="true">*</span>' : '';
      var nuevo = labels.length === 1 ? 'Tu inicial' : orig.replace(/^grabado\s+/i, 'Inicial del ').replace(/\bDije\b/, 'dije');
      lbl.innerHTML = esc(nuevo) + ast;
    });
    var inp = pz.querySelector('.engraving-addon__input');
    var max = inp ? parseInt(inp.getAttribute('maxlength'), 10) || 2 : 2;
    var ayuda = max <= 1 ? '1 letra · ' : (max === 2 ? '1 o 2 letras · ' : '1 a ' + max + ' letras · ');
    pz.querySelectorAll('.engraving-addon__help > span').forEach(function (help) {
      Array.prototype.forEach.call(help.childNodes, function (n) { if (n.nodeType === 3 && /m[aá]ximo/i.test(n.textContent)) n.textContent = ayuda; });
    });
  }

  function todo() {
    etiquetaInicial();
    var n = 0;
    document.querySelectorAll('variant-picker').forEach(function (vp) { var p = armaPicker(vp); if (p) n = p; });
    var fieldsets = document.querySelectorAll('variant-picker fieldset.variant-picker__option');
    if (!n) n = fieldsets.length;
    var hayOpcionGrabado = false;
    fieldsets.forEach(function (fs) { var lg = fs.querySelector('legend'); if (lg && ES_GRABADO.test(lg.textContent)) hayOpcionGrabado = true; });
    armaGrabado(n + 1, hayOpcionGrabado);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  window.addEventListener('load', todo);
})();
  })();

  /* ===== tipografias 1/1: Tipografias v3 paso 4 ===== */
  (function () {
(function () {
  var PID = CFG.pid;
  // valor del <select> → { familia CSS, escala de tamaño, origen de la fuente }
  var CDN = 'https://cdn.shopify.com/s/files/1/0735/6533/9962/files/';
  var FUENTES = {
    'Arial':             { css: 'Arial, Helvetica, sans-serif', k: 1 },
    'Code Light':        { css: '"DajoCodeLight", "Josefin Sans", sans-serif', k: 1.05, face: { name: 'DajoCodeLight', url: CDN + 'fuente-code-light.otf?v=1790794119', fmt: 'opentype' } },
    'Courier New':       { css: '"Courier New", Courier, monospace', k: 1 },
    'Long Time':         { css: '"Arsenal SC", serif', k: 1.05, google: 'Arsenal+SC' },
    'Baskerville':       { css: 'Baskerville, "Libre Baskerville", serif', k: 1, google: 'Libre+Baskerville' },
    'Times New Roman':   { css: '"Times New Roman", Times, serif', k: 1 },
    'Snell Roundhand':   { css: '"Snell Roundhand", "Great Vibes", cursive', k: 1.35, google: 'Great+Vibes' },
    'Segoe Script':      { css: '"Segoe Script", Kalam, cursive', k: 1.05, google: 'Kalam' },
    'Learning Curve':    { css: '"DajoLearningCurve", cursive', k: 1.3, face: { name: 'DajoLearningCurve', url: CDN + 'fuente-learning-curve.ttf?v=1790794119', fmt: 'truetype' } },
    'Jenna Sue':         { css: '"Nothing You Could Do", cursive', k: 1.1, google: 'Nothing+You+Could+Do' },
    'Old London':        { css: '"DajoOldLondon", serif', k: 1.15, face: { name: 'DajoOldLondon', url: CDN + 'fuente-old-london.ttf?v=1790794119', fmt: 'truetype' } },
    'Ancient':           { css: '"DajoCloisterBlack", serif', k: 1.15, face: { name: 'DajoCloisterBlack', url: CDN + 'fuente-cloister-black.ttf?v=1790794119', fmt: 'truetype' } }
  };
  // Cuadrícula de 3 columnas: [familia, [tipografías…]]  (Learning Curve oculta hasta tener licencia web de bvfonts)
  var COLUMNAS = [
    ['Minimalistas', ['Arial', 'Code Light', 'Long Time']],
    ['Cursivas', ['Snell Roundhand', 'Segoe Script', 'Jenna Sue']],
    ['Clásicas', ['Baskerville', 'Times New Roman', 'Courier New']]
  ];
  // Fila de abajo, a todo lo ancho: [familia, [tipografías…]]
  var FILA = ['Góticas', ['Old London', 'Ancient']];
  var ES_GRABADO = /grabado/i;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var fuentesCargadas = false;
  function cargaFuentes() {
    if (fuentesCargadas) return;
    fuentesCargadas = true;
    var g = [], css = '';
    Object.keys(FUENTES).forEach(function (n) {
      var f = FUENTES[n];
      if (f.google) g.push('family=' + f.google);
      if (f.face) css += '@font-face{font-family:"' + f.face.name + '";src:url("' + f.face.url + '") format("' + f.face.fmt + '");font-display:swap;}\n';
    });
    if (css) { var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st); }
    if (g.length) {
      var l = document.createElement('link'); l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?' + g.join('&') + '&display=swap';
      document.head.appendChild(l);
    }
  }

  function arma() {
    var sel = document.getElementById('typo-select-' + PID);
    var typeSel = document.getElementById('grabado-type-sel-' + PID);
    if (!sel || sel.getAttribute('data-dajo-tipo') === '1') return;
    sel.setAttribute('data-dajo-tipo', '1');
    var wrap = sel.closest('.engraving-addon--typo') || sel.parentElement;
    var label = wrap.querySelector('label.engraving-addon__label');
    if (label) label.classList.add('dajo-oculto');
    sel.classList.add('dajo-oculto');

    // número de paso: opciones de la pieza + grabado (+1 si el bloque de grabado tiene su propio paso)
    var fieldsets = document.querySelectorAll('variant-picker fieldset.variant-picker__option');
    var hayOpcionGrabado = false;
    fieldsets.forEach(function (fs) { var lg = fs.querySelector('legend'); if (lg && ES_GRABADO.test(lg.textContent)) hayOpcionGrabado = true; });
    var paso = fieldsets.length + (hayOpcionGrabado ? 1 : 2);

    var box = document.createElement('div');
    box.className = 'dajo-tipo';
    var titulo = document.createElement('p');
    titulo.className = 'dajo-paso__titulo dajo-tipo__titulo';
    titulo.innerHTML = '<span class="dajo-sel__paso">' + paso + '.</span>Elige tu tipografía';
    box.appendChild(titulo);

    var disponibles = {};
    Array.prototype.forEach.call(sel.options, function (o) { if (o.value) disponibles[o.value] = true; });

    function boton(nombre) {
      if (!disponibles[nombre] || !FUENTES[nombre]) return null;
      var f = FUENTES[nombre];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dajo-tipo__btn';
      b.setAttribute('data-value', nombre);
      b.setAttribute('aria-pressed', sel.value === nombre ? 'true' : 'false');
      b.setAttribute('title', nombre);
      b.innerHTML = '<span style="font-family:' + esc(f.css) + ';font-size:' + f.k + 'em">' + esc(nombre) + '</span>';
      b.addEventListener('click', function () {
        if (sel.value === nombre) return;
        sel.value = nombre;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        pinta();
      });
      return b;
    }
    function encabezado(texto) { var h = document.createElement('p'); h.className = 'dajo-tipo__fam'; h.textContent = texto; return h; }

    // Cuadrícula 3 × 3
    var cols = document.createElement('div');
    cols.className = 'dajo-tipo__cols';
    COLUMNAS.forEach(function (col) {
      var c = document.createElement('div');
      c.className = 'dajo-tipo__col';
      c.appendChild(encabezado(col[0]));
      col[1].forEach(function (nombre) { var b = boton(nombre); if (b) c.appendChild(b); });
      cols.appendChild(c);
    });
    box.appendChild(cols);

    // Fila de abajo a todo lo ancho (góticas), dos botones de la mitad cada uno
    var fila = document.createElement('div');
    fila.className = 'dajo-tipo__fila';
    fila.appendChild(encabezado(FILA[0]));
    var filaBtns = document.createElement('div');
    filaBtns.className = 'dajo-tipo__fila-btns';
    FILA[1].forEach(function (nombre) { var b = boton(nombre); if (b) filaBtns.appendChild(b); });
    fila.appendChild(filaBtns);
    box.appendChild(fila);

    wrap.insertBefore(box, wrap.firstChild);

    function inputsLaser() {
      var grupo = document.getElementById('laser-group-' + PID);
      return grupo ? Array.prototype.slice.call(grupo.querySelectorAll('input.engraving-addon__input')) : [];
    }
    function pinta() {
      var v = sel.value;
      box.querySelectorAll('.dajo-tipo__btn').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-value') === v ? 'true' : 'false'); });
      var f = FUENTES[v];
      inputsLaser().forEach(function (i) {
        if (f) { i.classList.add('dajo-tipo-vivo'); i.style.fontFamily = f.css; i.style.fontSize = (20 * f.k) + 'px'; }
        else { i.classList.remove('dajo-tipo-vivo'); i.style.fontFamily = ''; i.style.fontSize = ''; }
      });
      var err = document.getElementById('typo-error-' + PID);
      if (err && v) err.hidden = true;
    }
    sel.addEventListener('change', pinta);

    // Las fuentes solo se cargan cuando eligen láser (o si ya está elegido)
    // Al cambiar de técnica el bloque de grabado limpia el select sin avisar: se repinta siempre
    function revisa() { if (typeSel && typeSel.value === 'laser') cargaFuentes(); pinta(); }
    if (typeSel) typeSel.addEventListener('change', function () { setTimeout(revisa, 0); });
    revisa();
    pinta();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arma); else arma();
  window.addEventListener('load', arma);
})();
  })();

  /* ===== cadena 1/1: Dijes: largo de cadena + guia de tallas (lightbox) ===== */
  (function () {
(function(){
  var root = document.getElementById('dajo-cc');
  if(!root || root.dataset.init) return;
  root.dataset.init = '1';

  var imgs = [
    { src: root.dataset.i1, alt: root.dataset.a1 },
    { src: root.dataset.i2, alt: root.dataset.a2 }
  ];
  var lb = root.querySelector('.dajo-cc-lb');
  var stageImg = lb.querySelector('.dajo-cc-stage img');
  var dotsWrap = lb.querySelector('.dajo-cc-dots');
  var current = 0;

  imgs.forEach(function(_, i){
    var d = document.createElement('button');
    d.type='button'; d.setAttribute('aria-label','Imagen '+(i+1));
    d.addEventListener('click', function(){ show(i); });
    dotsWrap.appendChild(d);
  });
  var dots = Array.prototype.slice.call(dotsWrap.children);

  function show(i){
    current = (i + imgs.length) % imgs.length;
    stageImg.src = imgs[current].src;
    stageImg.alt = imgs[current].alt;
    dots.forEach(function(d,idx){ d.classList.toggle('is-active', idx===current); });
  }
  function open(i){
    show(i);
    lb.hidden = false; lb.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    lb.hidden = true; lb.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  root.querySelector('.dajo-cc-trigger').addEventListener('click', function(){ open(0); });
  lb.querySelector('.dajo-cc-close').addEventListener('click', close);
  lb.querySelector('.dajo-cc-prev').addEventListener('click', function(){ show(current-1); });
  lb.querySelector('.dajo-cc-next').addEventListener('click', function(){ show(current+1); });
  lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
  document.addEventListener('keydown', function(e){
    if(lb.hidden) return;
    if(e.key === 'Escape') close();
    if(e.key === 'ArrowLeft') show(current-1);
    if(e.key === 'ArrowRight') show(current+1);
  });

  var x0 = null;
  lb.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
  lb.addEventListener('touchend', function(e){
    if(x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if(Math.abs(dx) > 40){ show(dx < 0 ? current+1 : current-1); }
    x0 = null;
  }, {passive:true});
})();
  })();

  /* ===== trust 1/1: Trust micro-block v11: MSI segun variante ===== */
  (function () {
(function () {
  var pid = CFG.pid;
  var el = document.querySelector('[data-dajo-trust-msi-' + pid + ']');
  if (!el || el.getAttribute('data-listo') === '1') return;
  el.setAttribute('data-listo', '1');
  var MIN_3 = CFG.msi.min3, MIN_6 = CFG.msi.min6;
  var PRECIOS = CFG.precios;
  function variante() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (f) { var i = f.querySelector('[name="id"]'); if (i && i.value) return String(i.value); }
    try { return new URLSearchParams(window.location.search).get('variant'); } catch (e) { return null; }
  }
  function pinta() {
    var id = variante();
    var c = (id != null && PRECIOS[id] != null) ? PRECIOS[id] : null;
    if (c == null) return;
    var pesos = c / 100;
    var n = pesos >= MIN_6 ? 6 : (pesos >= MIN_3 ? 3 : 0);
    el.innerHTML = n ? 'Pago seguro<br>hasta ' + n + ' MSI' : 'Pago seguro';
  }
  pinta();
  ['variant:change', 'on:variant:change', 'variant:changed', 'product:variant-change',
   'product-info:variant-change', 'variantChange'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(pinta, 60); });
  });
  var f = document.querySelector('form[action*="/cart/add"]');
  if (f) {
    f.addEventListener('change', function () { setTimeout(pinta, 120); });
    var i = f.querySelector('[name="id"]');
    if (i) { var ult = i.value; setInterval(function () { if (i.value !== ult) { ult = i.value; pinta(); } }, 400); }
  }
})();
  })();

  /* ===== comosevera 1/2: Como se vera mi inicial v6: Seleccionado + zoom ===== */
  (function () {
  (function () {
    var box = document.getElementById('dajo-engrave-' + PID + '');
    if (!box || box.getAttribute('data-listo') === '1') return;
    box.setAttribute('data-listo', '1');
    // Marca "Seleccionado" en la técnica elegida en el selector de grabado
    var typeSel = document.getElementById('grabado-type-sel-' + PID + '');
    function marca() {
      var v = typeSel ? String(typeSel.value || '').toLowerCase() : '';
      var k = /laser|láser/.test(v) ? 'laser' : (/punz/.test(v) ? 'punzon' : '');
      box.querySelectorAll('.dajo-pdp-engrave__tech').forEach(function (t) { t.classList.toggle('is-elegida', !!k && t.getAttribute('data-tech') === k); });
    }
    if (typeSel) { typeSel.addEventListener('change', marca); marca(); }
    document.addEventListener('change', function (e) { if (e.target && e.target.tagName === 'SELECT') setTimeout(marca, 0); });
  })();
  })();

  /* ===== comosevera 2/2: Como se vera mi inicial v6: Seleccionado + zoom ===== */
  (function () {
  (function () {
    var wrap = document.getElementById('dajo-engrave-' + PID + '');
    var img = document.getElementById('dajo-engrave-zoom-img-' + PID + '');
    var btn = document.getElementById('dajo-engrave-zoom-btn-' + PID + '');
    if (!wrap || !img || !btn || wrap.getAttribute('data-zoom') === '1') return;
    wrap.setAttribute('data-zoom', '1');
    wrap.addEventListener('click', function (e) {
      var foto = e.target && e.target.closest && e.target.closest('.dajo-pdp-engrave__cell img');
      if (!foto) return;
      img.src = foto.currentSrc || foto.src;
      img.alt = foto.alt || 'Inicial grabada';
      btn.click();
    });
  })();
  })();

  /* ===== videos 1/1: Videos creadores v2: pop-up ===== */
  (function () {
  (function () {
    var root = document.getElementById('dajo-sp-' + PID + '');
    var lb = document.getElementById('dajo-spl-' + PID + '');
    if (!root || !lb || root.getAttribute('data-listo') === '1') return;
    root.setAttribute('data-listo', '1');
    if (lb.parentNode !== document.body) document.body.appendChild(lb); // fuera de la ficha para que el fixed no dependa de ningún contenedor

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.dajo-sp__thumb'));
    var pista = lb.querySelector('.dajo-spl__pista');
    var cerrarBtn = lb.querySelector('.dajo-spl__cerrar');
    var slides = Array.prototype.slice.call(lb.querySelectorAll('.dajo-spl__slide'));
    var vids = slides.map(function (s) { return s.querySelector('video'); });
    var dots = Array.prototype.slice.call(lb.querySelectorAll('.dajo-spl__dot'));
    var actual = 0, abierto = false, tmr;

    // Miniaturas: primer cuadro del video cuando el bloque se acerca a la pantalla
    function cargaThumbs() {
      thumbs.forEach(function (t) {
        var v = t.querySelector('video');
        if (v && !v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); v.preload = 'metadata'; v.load(); }
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cargaThumbs(); io.disconnect(); } }); }, { rootMargin: '300px 0px' });
      io.observe(root);
    } else { cargaThumbs(); }

    function cargaVideo(i) {
      var v = vids[i];
      if (v && !v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); v.preload = 'auto'; v.load(); }
    }
    function pausaTodos() {
      vids.forEach(function (v, k) { if (!v.paused) v.pause(); slides[k].classList.remove('is-playing'); });
    }
    function reproduce(i) {
      cargaVideo(i);
      var v = vids[i];
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      slides[i].classList.add('is-playing');
    }
    function pintaDots() { dots.forEach(function (d, k) { d.classList.toggle('is-active', k === actual); }); }
    function irA(i, directo) { pista.scrollTo({ left: i * pista.clientWidth, behavior: directo ? 'auto' : 'smooth' }); }

    function abre(i) {
      abierto = true; actual = i;
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      irA(i, true);
      if (i + 1 < vids.length) cargaVideo(i + 1);
      reproduce(i);
      pintaDots();
      cerrarBtn.focus();
    }
    function cierra() {
      if (!abierto) return;
      abierto = false;
      pausaTodos();
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { abre(parseInt(t.getAttribute('data-i'), 10) || 0); });
    });
    cerrarBtn.addEventListener('click', cierra);
    document.addEventListener('keydown', function (e) { if (abierto && e.key === 'Escape') cierra(); });

    // Toque en el fondo → cierra; toque en el video → play/pausa; toque en @usuario → abre Instagram
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.dajo-spl__cerrar')) return;
      var marco = e.target.closest('.dajo-spl__marco');
      if (!marco) { cierra(); return; }
      if (e.target.closest('.dajo-spl__tag')) return;
      var i = slides.indexOf(marco.parentNode);
      if (i < 0) return;
      if (vids[i].paused) { pausaTodos(); reproduce(i); }
      else { vids[i].pause(); slides[i].classList.remove('is-playing'); }
    });

    // Deslizar: al terminar el desplazamiento se reproduce el video visible y se pausa el anterior
    pista.addEventListener('scroll', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () {
        if (!abierto) return;
        var i = Math.round(pista.scrollLeft / pista.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== actual) {
          actual = i;
          pausaTodos();
          reproduce(i);
          if (i + 1 < vids.length) cargaVideo(i + 1);
          pintaDots();
        }
      }, 120);
    }, { passive: true });

    vids.forEach(function (v, k) { v.addEventListener('ended', function () { slides[k].classList.remove('is-playing'); }); });
    window.addEventListener('resize', function () { if (abierto) irA(actual, true); });
  })();
  })();

  /* ===== regalo 1/1: Regalo grid: Anadir deslizable ===== */
  (function () {
(function () {
  function arma(root) {
    if (root.getAttribute('data-anadir') === '1') return;
    root.setAttribute('data-anadir', '1');

    root.querySelectorAll('[data-regalo-card]').forEach(function (card) {
      var foto = card.querySelector('.dajo-regalo__foto');
      var mas = card.querySelector('[data-regalo-add]');
      if (!foto || !mas) return;

      var barra = document.createElement('button');
      barra.type = 'button';
      barra.className = 'dajo-regalo__anadir';
      barra.textContent = 'Añadir';
      barra.setAttribute('aria-label', mas.getAttribute('aria-label') || 'Agregar');
      foto.appendChild(barra);

      var timer = null;
      function pinta() {
        clearTimeout(timer);
        if (mas.classList.contains('is-elegido')) { barra.textContent = '✓ Agregado'; return; }
        if (mas.classList.contains('is-ok')) {
          barra.textContent = '✓ Agregado';
          timer = setTimeout(function () { barra.textContent = 'Añadir'; }, 1800);
          return;
        }
        if (mas.classList.contains('is-error')) { barra.textContent = 'Intenta de nuevo'; return; }
        if (mas.disabled) { barra.textContent = 'Agregando…'; return; }
        barra.textContent = 'Añadir';
      }
      try {
        new MutationObserver(pinta).observe(mas, { attributes: true, attributeFilter: ['class', 'disabled'] });
      } catch (e) {}

      // Primer toque en la foto: abre la barra. Segundo toque (barra abierta): navega a la ficha del extra.
      foto.addEventListener('click', function (e) {
        if (e.target === barra || barra.contains(e.target)) return;
        var abierta = card.classList.contains('is-open') || card.classList.contains('is-elegido');
        if (abierta) return; // deja pasar el clic al enlace de la foto
        e.preventDefault();
        root.querySelectorAll('[data-regalo-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
        card.classList.add('is-open');
      });

      // La barra dispara el "+" de siempre. Si ya quedó apuntado, no hace nada (no lo quita).
      barra.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (mas.disabled || mas.classList.contains('is-elegido')) return;
        mas.click();
        pinta();
      });
    });
  }

  function todo() { document.querySelectorAll('.dajo-regalo').forEach(arma); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  window.addEventListener('load', todo);
})();
  })();

  /* ===== resenas 1/1: Header de resenas v2 ===== */
  (function () {
  (function () {
    var head = document.getElementById('dajo-rev-head-' + PID + '');
    if (!head || head.getAttribute('data-listo') === '1') return;
    head.setAttribute('data-listo', '1');
    var titulo = head.querySelector('[data-rev-title]');
    var sub = head.querySelector('[data-rev-sub]');
    var total = 0;

    // 1) Título con número, leído del badge de Judge.me de la pieza (carga asíncrona: se reintenta hasta 20 s)
    function leeBadge() {
      var b = document.querySelector('.jdgm-prev-badge[data-average-rating]');
      if (!b) return false;
      var prom = parseFloat(b.getAttribute('data-average-rating'));
      var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
      if (!prom || !n) return false;
      total = n;
      titulo.innerHTML = '<span class="dajo-pdp-social-header__star" aria-hidden="true">\u2605</span><span class="dajo-pdp-social-header__num">' + prom.toFixed(1) + '</span> de 5 en ' + n.toLocaleString('es-MX') + ' rese\u00f1as';
      sub.hidden = false;
      if (btn) btn.textContent = 'Ver las ' + n.toLocaleString('es-MX') + ' rese\u00f1as';
      return true;
    }
    var intentos = 0;
    var tmr = setInterval(function () { if (leeBadge() || ++intentos > 40) clearInterval(tmr); }, 500);

        // 2) Widget colapsado a 3 reseñas + botón "Ver las N reseñas".
    //    El widget vive en la sección de apps, que va DESPUÉS de este bloque en el HTML: hay que esperar a que
    //    el documento termine de cargarse (si no, todavía no existe cuando corre este script).
    var btn = null;
    function colapsa() {
      var widget = document.getElementById('judgeme_product_reviews');
      if (!widget || widget.getAttribute('data-dajo-colapsado') === '1') return;
      widget.setAttribute('data-dajo-colapsado', '1');
      var cont = widget.closest('.shopify-section') || widget.parentElement;
      cont.classList.add('dajo-rev-colapsado');
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dajo-rev-btn';
      btn.textContent = total ? 'Ver las ' + total.toLocaleString('es-MX') + ' reseñas' : 'Ver más reseñas';
      widget.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        cont.classList.remove('dajo-rev-colapsado');
        btn.hidden = true;
      });
      // Si la pieza tiene 3 reseñas o menos, el botón no hace falta
      var chk = setInterval(function () {
        var items = widget.querySelectorAll('.jdgm-review-list > .jm-review-item');
        if (items.length) { clearInterval(chk); if (items.length <= 3 && !widget.querySelector('.jm-pagination-controls')) btn.hidden = true; }
      }, 700);
      setTimeout(function () { clearInterval(chk); }, 20000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', colapsa); else colapsa();
    window.addEventListener('load', colapsa);
  })();
  })();

  /* ===== sticky 1/1: Sticky CTA v13 ===== */
  (function () {
  (function() {
    'use strict';

    var stickyCta = document.getElementById('dajoStickyCta');
    if (!stickyCta) return;

        var STICKY_THRESHOLD = 200;      // respaldo si la pieza no tiene ruta de navegación (.dajo-bc)
    var FREE_SHIPPING_CENTS = 129900; // $1,299
    var FORM_ID = CFG.formId;
    var productData = { variants: CFG.variants }; /* dajo-aud-19sep: antes product | json completo, 30-150 KB por ficha */

    var stickyVariantEl = document.getElementById('dajoStickyVariant');
    var stickyPriceEl = document.getElementById('dajoStickyPrice');
    var stickyCompareEl = document.getElementById('dajoStickyCompare');
    var stickyShipEl = document.getElementById('dajoStickyShip');
    var stickyAddBtn = document.getElementById('dajoStickyAddBtn');

    function getMainForm() {
      return document.getElementById(FORM_ID);
    }

    function getMainButton() {
      var form = getMainForm();
      return document.querySelector('.product-info buy-buttons button[type="submit"]') ||
             (form && form.querySelector('button[type="submit"]')) ||
             document.querySelector('button[type="submit"][form="' + FORM_ID + '"]');
    }

    // ─── 1. Mostrar y esconder ───
    function activateSticky() {
      stickyCta.classList.add('is-visible');
      stickyCta.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dajo-sticky-active');
    }

    function deactivateSticky() {
      stickyCta.classList.remove('is-visible');
      stickyCta.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dajo-sticky-active');
    }

    function mainButtonInView() {
      var btn = getMainButton();
      if (!btn || !btn.offsetParent) return false;
      var r = btn.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

        // v13: el sticky aparece solo cuando el botón principal ya salió de la pantalla por arriba (se pasó de largo)
    function ctaArriba() {
      var btn = getMainButton();
      if (!btn || !btn.offsetParent) return window.scrollY > STICKY_THRESHOLD;
      return btn.getBoundingClientRect().bottom < 0;
    }

    var ticking = false;
    function handleScroll() {
                  if (ctaArriba()) {
        activateSticky();
      } else {
        deactivateSticky();
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }, { passive: true });

        handleScroll();
    window.addEventListener('load', handleScroll);
    window.addEventListener('resize', handleScroll);

    // ─── 2. "Cambiar" → scroll suave al selector de variante ───
    var changeBtn = document.getElementById('dajoStickyChange');
    if (changeBtn) {
      changeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector('.product-info variant-picker') ||
                     document.querySelector('variant-picker') ||
                     getMainButton();
        if (target) {
          var top = target.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: Math.max(0, top - 100), behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    // ─── 3. Sincronizar variante, precio y envio ───
    function formatMoney(cents) {
      var pesos = cents / 100;
      var txt = (pesos % 1 === 0) ? String(pesos) : pesos.toFixed(2);
      var parts = txt.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function updateStickyFromVariantId(variantId) {
      if (!variantId || !productData || !productData.variants) return;
      var variant = productData.variants.find(function(v) { return v.id == variantId; });
      if (!variant) return;

      if (stickyVariantEl) stickyVariantEl.textContent = variant.title || '';
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

      if (stickyCompareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          stickyCompareEl.textContent = formatMoney(variant.compare_at_price);
          stickyCompareEl.style.display = '';
        } else {
          stickyCompareEl.style.display = 'none';
        }
      }

      if (stickyShipEl) {
        stickyShipEl.textContent = variant.price >= FREE_SHIPPING_CENTS
          ? 'Envío gratis en esta pieza'
          : 'Envío gratis a partir de $1,299';
      }

      if (stickyAddBtn) {
        stickyAddBtn.dataset.variantId = variant.id;
        stickyAddBtn.disabled = !variant.available;
        stickyAddBtn.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      }
    }

    var mainForm = getMainForm();
    var variantInput = mainForm ? mainForm.querySelector('[name="id"]') : null;

    function syncFromInput() {
      if (variantInput) updateStickyFromVariantId(variantInput.value);
    }

    if (variantInput) {
      new MutationObserver(syncFromInput).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', syncFromInput);
    }

    document.addEventListener('variant:change', function(e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) { updateStickyFromVariantId(v.id); } else { syncFromInput(); }
    });

    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) {
        setTimeout(syncFromInput, 100);
      }
    });

    // ─── 4. Clic en el boton del sticky ───
    // Le da clic al boton principal: asi el pedido lleva la inicial, el grabado,
    // la tipografia y los complementos, igual que si lo agregaran desde arriba.
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        var mainBtn = getMainButton();
        var originalText = 'Añadir al carrito';

        function restore() {
          setTimeout(function() {
            stickyAddBtn.textContent = originalText;
            stickyAddBtn.disabled = false;
          }, 1800);
        }

        stickyAddBtn.disabled = true;
        stickyAddBtn.textContent = 'Agregando...';

        if (mainBtn && !mainBtn.disabled && mainBtn.getAttribute('aria-disabled') !== 'true') {
          mainBtn.click();
          restore();
          return;
        }

        // Respaldo: mandar el formulario completo (incluye los campos con atributo form)
        var form = getMainForm();
        if (!form) { stickyAddBtn.textContent = originalText; stickyAddBtn.disabled = false; return; }

        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function(res) { return res.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            restore();
          })
          .catch(function(err) {
            console.error('DAJO Sticky CTA: error al agregar al carrito', err);
            stickyAddBtn.textContent = 'Error';
            restore();
          });
      });
    }
  })();
  })();

})();